export default __webpack_public_path__ + "static/selo-gptw-2023-891125d11621e56fcc377d97f94a8f4b.svg";